import React from 'react'
import { Redirect } from 'react-router-dom'
import { SEO } from '../../../../components/Seo/seo'
import { FormattedMessage, useIntl } from 'react-intl'
import Layout from '../../../../components/Dashboard/Layout/Layout'
import { NamedRoutes } from '../../../../routes'
import { addPlan } from '../../../../utils/pages-meta.json'
import { AuthenticatedUserConsumer } from '../../../../AuthenticatedUserContext'
import { PlanProvider } from '../../../../PlanContext'
import { FormLoader } from '../../../../components/Loader/FormLoader'
import PlanEditContent from '../../../../components/Dashboard/Subscription/PlanEditContent'


const SinglePlanAdd = () => {
  const intl = useIntl()
  return (
    <>
      <SEO title={intl.formatMessage({ id: 'Plans.List.AddPlan.Title' })}
           pathname={window.location.origin}
           titleTemplate={intl.formatMessage({ id: 'E-Tax' })}
           image={addPlan.image}
           description={intl.formatMessage({ id: 'Plans.List.AddPlan.Title' })}
      />
      <AuthenticatedUserConsumer>
        {({ userDataLoading, userData, handleNotificationCall }) => (
          <>
            {!!userDataLoading && <FormLoader loading={true}/>}
            {!!Object.keys(userData).length &&
            <>
              {!!userData.is_admin ? <Layout content={
                <PlanProvider pageAction={'add'} handleNotificationCall={handleNotificationCall}>
                  <PlanEditContent pageTitle={<FormattedMessage id='Plans.List.AddPlan.Title'/>}/>
                </PlanProvider>
              }/> : (!userDataLoading && <Redirect to={NamedRoutes.home}/>)
              }
            </>
            }
          </>
        )}
      </AuthenticatedUserConsumer>
    </>
  )
}

export default SinglePlanAdd

